import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Save } from "lucide-react";

const FIELDS = [
  { key: "projects", label: "Tamamlanan Proje", section: "Rakamlar" },
  { key: "area", label: "İnşaat Alanı", section: "Rakamlar" },
  { key: "families", label: "Mutlu Aile", section: "Rakamlar" },
  { key: "experience", label: "Yıllık Tecrübe", section: "Rakamlar" },
  { key: "hero_title_line1", label: "Hero Başlık 1", section: "Ana Sayfa Hero" },
  { key: "hero_title_line2", label: "Hero Başlık 2 (altın)", section: "Ana Sayfa Hero" },
  { key: "hero_subtitle", label: "Hero Alt Metin", section: "Ana Sayfa Hero", textarea: true },
  { key: "about_text", label: "Kurumsal Hakkımızda Metni", section: "Kurumsal", textarea: true },
  { key: "phone", label: "Telefon", section: "İletişim" },
  { key: "email", label: "E-posta", section: "İletişim" },
  { key: "address", label: "Adres", section: "İletişim", textarea: true },
];

export default function AdminSettings() {
  const [form, setForm] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => { api.get("/stats").then((r) => setForm(r.data)).catch(() => {}); }, []);

  const save = async () => {
    setLoading(true);
    try {
      await api.put("/stats", form);
      toast.success("Ayarlar kaydedildi");
    } catch (err) {
      toast.error("Hata: " + (err.response?.data?.detail || err.message));
    } finally { setLoading(false); }
  };

  const groups = FIELDS.reduce((acc, f) => { (acc[f.section] ||= []).push(f); return acc; }, {});

  return (
    <div className="p-8 lg:p-12 max-w-5xl" data-testid="admin-settings-page">
      <div className="flex items-center justify-between mb-10">
        <div>
          <div className="section-label mb-3">Ayarlar</div>
          <h1 className="font-heading text-3xl lg:text-4xl text-white tracking-[0.05em]">Site Ayarları</h1>
        </div>
        <button onClick={save} disabled={loading} className="btn-gold text-xs disabled:opacity-50" data-testid="save-settings-btn">
          <Save className="w-4 h-4" /> {loading ? "Kaydediliyor..." : "Kaydet"}
        </button>
      </div>

      <div className="space-y-10">
        {Object.entries(groups).map(([section, fields]) => (
          <div key={section} className="yk-card p-8">
            <div className="section-label mb-6">{section}</div>
            <div className="grid md:grid-cols-2 gap-5">
              {fields.map((f) => (
                <div key={f.key} className={f.textarea ? "md:col-span-2" : ""}>
                  <label className="text-xs uppercase tracking-[0.2em] text-white/70 block mb-2">{f.label}</label>
                  {f.textarea ? (
                    <textarea rows={3} className="yk-input resize-none" value={form[f.key] || ""} onChange={(e) => setForm({ ...form, [f.key]: e.target.value })} data-testid={`settings-${f.key}`} />
                  ) : (
                    <input type="text" className="yk-input" value={form[f.key] || ""} onChange={(e) => setForm({ ...form, [f.key]: e.target.value })} data-testid={`settings-${f.key}`} />
                  )}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
